/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Config from "../../../config/index";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import { getSubModulesByRoleId, getWoProcessLogReport } from "../../../store";

// Cookies
import Cookies from "universal-cookie";

import {
  Alert,
  Backdrop,
  CircularProgress,
  Collapse,
  IconButton,
  Modal,
} from "@mui/material";
import { addMinutes, format } from "date-fns";

import CloseIcon from "@mui/icons-material/Close";
import MDCard from "components/MDCard";

const desLength = Config.descriptionLength;

const cookies = new Cookies();

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const WOProcessLogReport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getWoProcessLogReport,
  getWoProcessLogReportReducer,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let stockAvailableReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6aeea796-9313-473c-abf9-da038212f7f3",
  );

  let viewAccess = stockAvailableReportModule
    ? stockAvailableReportModule.actionId.includes(
        "8a3b3511-9347-4d97-8acb-98f903f9b472",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    if (globalFilter) {
      const cleanedFilter = Object.fromEntries(
        Object.entries(globalFilter).filter(([key, value]) => value !== ""),
      );
      setSearchObject(JSON.stringify(cleanedFilter));
    } else {
      setSearchObject("");
    }
  };

  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [relectedRmw, setRelectedRmw] = useState("");
  const [selectedsf, setSelectedsf] = useState("");

  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      {
        Header: "WO Number",
        accessor: "poNumber",
        align: "left",
      },

      {
        Header: "Work Center",
        accessor: "workCenterCode",
        align: "left",
      },
      {
        Header: "Machine Center",
        accessor: "machineCode",
        align: "left",
      },
      {
        Header: "Operation",
        accessor: "operationCode",
        align: "left",
      },
      {
        Header: "Start Time",
        accessor: "startTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Time Spent",
        accessor: "actualSpentTime",
        align: "left",
      },
      {
        Header: "Hold Time",
        accessor: "restTime",
        align: "left",
      },

      {
        Header: "User",
        accessor: "userName",
        align: "left",
      },
      { Header: "Item Code", accessor: "itemCode" },

      { Header: "booked Suid", accessor: "bookedSuid" },

      { Header: "booked Qty", accessor: "bookedQty" },

      {
        Header: "booked Date",

        accessor: "bookedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      { Header: "consumed Suid", accessor: "consumedSuid" },
      { Header: "consumed Qty", accessor: "consumedQty" },
      {
        Header: "consumed Date",

        accessor: "consumedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getWoProcessLogReportReducer.woProcessLog.data
      ? getWoProcessLogReportReducer.woProcessLog.data
      : [];
    setPaginationObj(getWoProcessLogReportReducer.woProcessLog?.pagination);
    setLoading(getWoProcessLogReportReducer.loading);
    data?.map((singleGrn) => {
      let len = desLength;
      const finishedGoodsObject = {
        poNumber: singleGrn.poNumber,
        workCenterCode: singleGrn.workCenterCode,
        machineCode: singleGrn.machineCode,
        operationCode: singleGrn.operationCode,
        startTime: singleGrn.startTime,
        endTime: singleGrn?.endTime,

        actualSpentTime: singleGrn.actualSpentTime,
        restTime: singleGrn.restTime,
        sku: singleGrn.suid,
        bookedSuid: singleGrn.bookedSuid,
        itemCode: singleGrn.itemCode,

        rejectedLocation: singleGrn.rejectedLocation,
        consumedDate: singleGrn.consumedDate,
        bookedQty: `${singleGrn.bookedQty}`,
        consumedQty: `${singleGrn.consumedQty}`,
        userName: singleGrn.userName,
        bookedDate: singleGrn.bookedDate,
        consumedSuid: singleGrn.consumedSuid,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getWoProcessLogReportReducer]);

  const rmwOptions = [{ label: "No Stock", value: "0" }];
  const sfOptions = [{ label: "No Stock", value: "0" }];

  const handlesfChange = (selectedItemCode) => {
    setSelectedsf(selectedItemCode);
  };

  const handleRmwChange = (selectedItemCode) => {
    if (selectedItemCode) {
      setRelectedRmw(selectedItemCode);
    } else {
      setRelectedRmw(""); // Clear the value if it's not valid
    }
  };
  const [itemCodeOptions, setItemCodeOptions] = useState("");

  useEffect(() => {
    getWoProcessLogReport(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);

  const [downloadData, setDownloadData] = useState("");

  const headers = [
    { label: "Item Code", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Not Printed Grn ", key: "notPrintedGrnQty" },
    { label: "Ramco qty", key: "ramcoQty" },
    { label: "Rec Qty", key: "totalRecQty" },
    { label: "Rmw qty", key: "totalRmwQty" },
    { label: "SF qty", key: "totalSfQty" },
    { label: "quarantine qty", key: "quarantineQty" },
    { label: "rejection qty ", key: "rejectionQty" },
    { label: "MR qty", key: "totalMrQty" },
    { label: "bookedQty", key: "bookedQty" },
    { label: "consumned qty", key: "consumedQty" },
  ];
  const csvLink = {
    filename: "Stock Availability Report.csv",
    headers: headers,
    data: downloadData,
  };

  const subModuleId = "6e4eaf7f-b21a-4440-9015-37090e1e12e7";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  // useEffect(() => {
  //   getDynamicColumn(userId, subModuleId, jwtToken);
  // }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  console.log("downloadData", downloadData);

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getWoProcessLogReport(
        pageNo,
        rowsPerPage,
        searchObject,

        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                {/* <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      alignItems="center"
                      width="100%"
                    >
                      <MDBox
                        width={{ xs: "100%", lg: "200px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          RMW Stock
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          autoComplete="off"
                          value={relectedRmw}
                          options={rmwOptions}
                          onChange={handleRmwChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "100%", lg: "200px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          SF Stock
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          autoComplete="off"
                          value={selectedsf}
                          options={sfOptions}
                          onChange={handlesfChange}
                        />
                      </MDBox>

                      <MDBox
                        style={{
                          marginTop: "25px",
                          marginLeft: { xs: 0, lg: "8px" },
                        }}
                      >
                        {downloadData?.length > 0 ? (
                          <CSVLink {...csvLink}>
                            <DownloadDataButton
                              type="button"
                              style={{ borderRadius: "5px" }}
                              size="small"
                              variant="outlined"
                              color="success"
                              iconOnly
                              tooltip="Download All Data"
                            >
                              <Icon>download</Icon>
                            </DownloadDataButton>
                          </CSVLink>
                        ) : (
                          <DownloadDataButton
                            disabled
                            type="button"
                            style={{ borderRadius: "5px" }}
                            size="small"
                            variant="outlined"
                            color="success"
                            iconOnly
                            tooltip="No data to download"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid> */}
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    // hideColumns={["", "asnCode", "vendorCodeName"]}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getWoProcessLogReportReducer: state.getWoProcessLogReportReducer,

    itemMaster: state.itemMaster,
    downloadStockAvailabilityReducer: state.downloadStockAvailabilityReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getWoProcessLogReport: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getWoProcessLogReport(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(WOProcessLogReport);
